import React from 'react';
import ToggleTag from "@Generic/buttons/ToggleTag";
import {useTranslation} from "@Translation/hooks/useTranslation";
import intToBool from "@Number/intToBool";
import StationFeaturesType from "@Pages/countryPage/features/countryStations/types/StationFeatures.type";

interface StationTagFilterProps {
    onClick: (value: string) => void,
    activeTag: string,
    stationFeatureCount: StationFeaturesType
}

function StationTagFilter({onClick, activeTag, stationFeatureCount}: StationTagFilterProps) {
    const skiResortLabel = useTranslation('s_page.ski_resort')
    const nationalParkLabel = useTranslation('s_page.national_park')
    const {
        all: allLabel,
        island: islandLabel,
        popular_sight: popularSightLabel,
        holiday_destination: holidayDestinationLabel,
    } = useTranslation('country_page.country_bus_stations.tags')

    const {
        popularSightCount,
        holidayDestinationCount,
        skiResortCount,
        themeParkCount,
        nationalParkCount,
        islandCount,
    } = stationFeatureCount

    return (
        <>
            <ToggleTag
                onClick={onClick}
                value="all"
                label={allLabel}
                active={activeTag === 'all'}
            />

            {intToBool(skiResortCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isSkiResort"
                    label={skiResortLabel}
                    active={activeTag === 'isSkiResort'}
                />
            )}

            {intToBool(popularSightCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isPopularSight"
                    label={popularSightLabel}
                    active={activeTag === 'isPopularSight'}
                />
            )}

            {intToBool(islandCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isIsland"
                    label={islandLabel}
                    active={activeTag === 'isIsland'}
                />
            )}

            {intToBool(themeParkCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isThemePark"
                    label="Theme park"
                    active={activeTag === 'isThemePark'}
                />
            )}

            {intToBool(nationalParkCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isNationalPark"
                    label={nationalParkLabel}
                    active={activeTag === 'isNationalPark'}
                />
            )}

            {intToBool(holidayDestinationCount) && (
                <ToggleTag
                    onClick={onClick}
                    value="isHolidayDestination"
                    label={holidayDestinationLabel}
                    active={activeTag === 'isHolidayDestination'}
                />
            )}
        </>
    )
}

export default StationTagFilter;